import { inject, Pipe, PipeTransform } from '@angular/core';
import { API_BASE_FILE_URL } from '../utils';
import { FILE_API_URL } from '../constants/api-url';
import { BasePublicHttpService } from '../services';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Pipe({
  name: 'imageReader',
})
export class ImageReader implements PipeTransform {
  $api_base_url = inject(API_BASE_FILE_URL);
  private baseHttpService = inject(BasePublicHttpService);

  transform(value?: string, isUserPhoto = true): Observable<string> {
    if (!value) {
      return of('./images/user.png');
    }

    if (
      value.startsWith('http://') ||
      value.startsWith('https://') ||
      value.startsWith('data:')
    ) {
      return of(value);
    }

    if (isUserPhoto) {
      const url = FILE_API_URL.download_file.replace('id:', value);
      return this.baseHttpService.getBlob(url).pipe(
        map((blob: Blob) => URL.createObjectURL(blob)),
        catchError(() =>
          of(`${this.$api_base_url}files/${value}/download`),
        ),
      );
    }

    if (value.substring(0, 22) === 'data:image/png;base64,') {
      return of(value);
    }

    return of(`data:image/png;base64,${value}`);
  }
}
